<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >

    <div class="m-2">

      <!-- Table Top -->
      <b-row>
        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <TableEntries
            v-model="perPage"
            :options="perPageOptions"
          />
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-lg-end">
            <Button
              :label="$t('Filter')"
              size="md"
              icon="FilterIcon"
              show-icon
              class="mr-1"
              @click="showModal('modal-filter')"
            />
            <Button
              :label="$t('Reset Filter')"
              size="md"
              icon="RotateCwIcon"
              show-icon
              @click="resetFilter"
            />
          </div>
        </b-col>
      </b-row>
    </div>

    <b-table
      ref="refInterestTable"
      :items="routeConfigList"
      :busy="isBusy"
      responsive
      :fields="translatedTableHeaders"
      primary-key="id"
      show-empty
      :empty-text="$t('No records available')"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      class="position-relative"
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner
            class="align-middle"
            variant="primary"
          />
        </div>
      </template>

      <template #cell(SN)="data">
        {{ getOverallIndex(data.index) }}
      </template>
      <template #cell(dateCreated)="data">
        {{ toDateWithYear(data.value) }}
      </template>
      <template #cell(isThirdParty)="data">
        <b-badge
          :variant="getStatusColor(data.value ? 'Yes' : 'No')"
        >
          {{ data.value ? 'Yes' : 'No' }}
        </b-badge>
      </template>
      <template #cell(status)="data">
        <b-badge
          pill
          :variant="getStatusColor(data.value)"
        >
          {{ data.value }}
        </b-badge>
      </template>
      <!-- Column: Actions -->
      <template #cell(actions)="data">
        <div class="text-nowrap">
          <!-- Dropdown -->
          <b-dropdown
            variant="link"
            toggle-class="p-0"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item
              v-if="getUserPermission('UPDATE_CARD_CONFIG')"
              @click="onSelectInterestItem(data.item, $event.target, 'edit')"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">{{ $t('Modify') }}</span>
            </b-dropdown-item>

            <b-dropdown-item @click="onSelectInterestItem(data.item, $event.target, 'view')">
              <feather-icon icon="EyeIcon" />
              <span class="align-middle ml-50">{{ $t('View') }}</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="getUserPermission('UPDATE_CARD_CONFIG')"
              @click="generateKey(data.item, $event.target)"
            >
              <feather-icon icon="LockIcon" />
              <span class="align-middle ml-50">{{ $t('Generate Key Pairs') }}</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="getUserPermission('UPDATE_CARD_CONFIG')"
              @click="routeConfigStatus(data.item, $event.target)"
            >
              <feather-icon icon="CheckSquareIcon" />
              <span class="align-middle ml-50">{{ data.item.status === 'Active' ? $t('Deactivate') : $t('Activate') }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>

    </b-table>

    <TablePagination
      v-model="currentPage"
      :from="from"
      :to="to"
      :total-rows="totalEntries"
      :per-page="perPage"
    />

    <!-- modal -->
    <b-modal
      id="modal-lg"
      ref="my-modal"
      :ok-title="buttonLabel"
      cancel-title="Cancel"
      cancel-variant="outline-secondary"
      :ok-disabled="isLoading"
      centered
      size="lg"
      :title="modalTitle"
      @ok="handleSubmit"
      @hidden="resetModal"
    >
      <validation-observer ref="interestRules">
        <b-form>
          <b-row class="match-height">
            <!-- Interest Name -->
            <b-col md="6">
              <InputField
                id="providerInstitutionKey"
                v-model="routeConfigFormData.providerInstitutionId"
                :label="$t('Provider Institution Id')"
                :placeholder="$t('Enter provider institution id')"
                type="text"
                rules="required"
                for="providerInstitutionId"
                :error-name="$t('Provider Institution Id')"
                :readonly="isReadonly"
                onpaste="return false;"
                :is-allow-special-characters="false"
              />
            </b-col>
            <!-- Interest Name -->

            <!-- Type of Interest -->
            <b-col md="6">
              <InputField
                id="default-rate"
                v-model="routeConfigFormData.providerCustomerId"
                :label="$t('Provider Customer Id')"
                :placeholder="$t('Enter provider customer id')"
                type="text"
                :error-name="$t('Provider Customer Id')"
                rules="required"
                for="default-rate"
                :readonly="isReadonly"
              />
            </b-col>
          <!-- Type of Interest -->
          </b-row>

          <b-row class="match-height align-items-center">
            <!-- Default Rate -->
            <b-col md="6">
              <InputField
                id="default-rate"
                v-model="routeConfigFormData.providerGatewayKey"
                :label="$t('Provider Gateway Key')"
                :placeholder="$t('Enter provider gateway key')"
                type="text"
                :error-name="$t('Provider Gateway Key')"
                rules="required"
                for="default-rate"
                :readonly="isReadonly"
              />
            </b-col>
            <!-- Default Rate -->

            <b-col md="6">
              <InputField
                id="default-rate"
                v-model="routeConfigFormData.cardSettlementGL"
                :label="$t('Card Settlement GL')"
                :placeholder="$t('Enter card settlement gl')"
                type="text"
                :error-name="$t('Card Settlement GL')"
                rules="required"
                for="default-rate"
                :readonly="isReadonly"
              />
            </b-col>
          </b-row>

        </b-form>
      </validation-observer>
      <template
        v-if="isReadonly"
        #modal-footer="{ }"
      >
        <div />
      </template>
    </b-modal>
    <!-- modal -->

    <!-- Filter modal -->
    <b-modal
      id="modal-filter"
      ref="my-modal"
      :ok-title="$t('Apply')"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      centered
      size="lg"
      :title="$t('Filters')"
      modal-footer
      @ok="fetchRouteConfig"
      @cancel="resetFilters"
    >
      <b-row class="match-height">
        <!-- ThirdPartyProvider -->
        <b-col md="6">
          <SelectField
            id="thirdPartyProvider"
            v-model="filter.thirdPartyProvider"
            :label="$t('Third Party Provider')"
            :reduce="option=>option.value"
            :placeholder="$t('Select')"
            :options="thirdPartyProviderOptions"
            item="label"
          />
        </b-col>
        <!-- ThirdPartyProvider -->
      </b-row>
    </b-modal>
    <!-- Filter modal -->

    <!-- Generate Key Modal-->
    <b-modal
      id="key-display-modal"
      ref="KeyDisplayModal"
      centered
      size="md"
      ok-only
      :ok-title="$t('Close')"
      @ok="hideModal('key-display-modal'); fetchRouteConfig()"
    >
      <div class="p-0">
        <p class="section-label mb-3">
          {{ $t('Generated Key') }}
        </p>
        <div class="pin-container mb-3">
          <b-row
            class="match-height copy-button"
            md="3"
            @click="onCopyItem(generatedKey)"
          >
            <span>{{ $t('COPY') }}</span>
            <feather-icon
              icon="CopyIcon"
              class="cursor-pointer ml-1 "
            />
          </b-row>
          <div class="pin-display d-flex align-items-center justify-content-between">
            <span class="pin-code">{{ generatedKey }}</span>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- Generate Key Modal-->
    <FullScreenSpinner :show="showSpinner" />
  </b-card>

</template>

<script>
import {
  BCard, BRow, BCol, BTable,
  BDropdown, BDropdownItem, BModal, BForm, BBadge, BSpinner,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import { mapActions } from 'vuex'
import { required, positive } from '@validations'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { permissionMixin } from '@core/mixins/permission'
import TablePagination from '@/views/components/table/TablePagination.vue'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import TableEntries from '@/views/components/table/TableEntries.vue'
import InputField from '../../../forms/InputField.vue'
import SelectField from '../../../forms/SelectField.vue'
import { toDateWithYear } from '../../../../helpers/formatDate'
import { isThirdParty } from '../../../../helpers/data'
import getStatusColor from '../../../../helpers/getStatusColor'
import Button from '../../../components/button/Button.vue'
import { eChannelsPermission } from '../../../../helpers/permissions'

export default {
  components: {
    BCard,
    BRow,
    BSpinner,
    BCol,
    BBadge,
    BTable,
    BDropdown,
    BDropdownItem,
    BModal,
    BForm,
    ValidationObserver,
    InputField,
    SelectField,
    TablePagination,
    FullScreenSpinner,
    Button,
    TableEntries,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  data() {
    return {
      toDateWithYear,
      sortBy: 'type',
      isReadonly: false,
      modalTitle: this.$t('Create New Profit'),
      buttonLabel: this.$t('Save'),
      isBusy: false,
      required,
      positive,
      isDisableApplyWTH: false,
      showSpinner: false,
      getStatusColor,
      sortDesc: false,
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'dateCreated', sortable: true, label: 'Date Created' },
        { key: 'bankCode', sortable: true, label: 'Bank Code' },
        { key: 'thirdPartyProvider', sortable: true, label: 'Third Party Provider' },
        { key: 'isThirdParty', sortable: true, label: 'Is Third Party?' },
        { key: 'keyVersion', sortable: true, label: 'Key Version' },
        { key: 'providerInstitutionId', sortable: true, label: 'Provider Institution ID' },
        { key: 'providerGatewayKey', sortable: true, label: 'Provider Gateway Key' },
        { key: 'status', sortable: true, label: 'Status' },
        { key: 'actions', label: 'Actions' },
      ],
      datePickerConfig: {
        dateFormat: 'Y-m-d',
        maxDate: 'today',
        defaultDate: '',
        ariaDateFormat: 'Y-m-d',
      },
      filter: {
        thirdPartyProvider: '',
      },
      routeConfigFormData: {
        providerInstitutionId: '',
        providerCustomerId: '',
        providerGatewayKey: '',
        cardSettlementGL: '',
        providerBaseUrl: '',
        id: '',
      },
      routeConfigList: [],
      thirdPartyProviderOptions: [
        { value: 'PROVIDUS', label: 'Providus' },
      ],
      generatedKey: '',
    }
  },
  computed: {
    translatedTableHeaders() {
      return this.tableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    isThirdPartyOptions() {
      return isThirdParty.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.value }))
    },
  },
  watch: {
    currentPage(newValue) {
      this.currentPage = newValue
      this.fetchRouteConfig()
    },
    perPage(newValue) {
      this.perPage = newValue
      this.fetchRouteConfig()
    },
  },
  mounted() {
    this.fetchRouteConfig()
  },
  methods: {
    ...mapActions({
      getRouteConfigList: 'eChannels/getRouteConfigList',
      updateRouteConfig: 'eChannels/updateRouteConfigAction',
      updateKeyPair: 'eChannels/updateKeyPair',
      updateRouteConfigStatus: 'eChannels/updateRouteConfigStatus',
    }),
    onCopyItem(item) {
      try {
        navigator.clipboard.writeText(item)
        this.alertSuccess({ text: this.$t('Copied to Clipboard') })
      } catch (error) {
        this.alertError({ text: this.$t('Error copying to clipboard:'), error })
      }
    },
    setWithholdingTax(selectedValue, actionType) {
      if (selectedValue === 'Debit') {
        this.routeConfigFormData.applyWTH = false
        this.isDisableApplyWTH = true
      } else if (selectedValue === 'Credit' && actionType === 'view') {
        this.isDisableApplyWTH = true
      } else {
        this.routeConfigFormData.applyWTH = false
        this.isDisableApplyWTH = false
      }
    },
    async setupGenerateKey(item) {
      this.useCardId = item.cardId
      this.$root.$emit('bv::show::modal', 'key-display-modal')
    },
    async routeConfigStatus(items) {
      const { id, status } = items
      const actionType = status === 'Active' ? 1 : 2
      const action = status === 'Active' ? this.$t('Deactivate') : this.$t('Activate')

      const updateStatus = async () => {
        try {
          this.showSpinner = true
          const formData = {
            id,
            status: actionType,
          }
          const response = await this.updateRouteConfigStatus(
            { formData, permission: eChannelsPermission.UPDATE_CARD_CONFIG },
          )
          if (response.status === 200) {
            this.fetchRouteConfig()
            const requestToText = this.$t('Your request to')
            const text = this.$t('Route Config was successful')
            this.alertSuccess({ text: `${requestToText} ${action} ${text}` })
            this.showSpinner = false
          }
        } catch (error) {
          const requestToText = this.$t('Your request to')
          const reasonText = this.$t('Route Config failed. Reason')
          this.alertError({ text: `${requestToText} ${action} ${reasonText}: ${error}` })
        } finally {
          this.showSpinner = false
        }
      }
      const areYouSure = this.$t('Are you sure you want to')
      const pdText = this.$t('this Route Config')
      this.confirm(updateStatus, { title: '', text: `${areYouSure} ${action} ${pdText}?` })
    },
    handleSubmit(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.$refs.interestRules.validate().then(async success => {
        if (success) {
          const areYouSure = this.$t('Are you sure you want to')
          const pdText = this.$t('this Route Config')
          this.confirm(this.interestManagementAction, { text: `${areYouSure} ${this.buttonLabel} ${pdText}?` })
        }
      })
    },
    async interestManagementAction() {
      try {
        this.isLoading = true
        const formData = {
          ...this.routeConfigFormData,
        }
        const response = this.buttonLabel === this.$t('Save')
          ? await this.createInterest({ formData, permission: eChannelsPermission.UPDATE_CARD_CONFIG })
          : await this.updateRouteConfig({ formData, permission: eChannelsPermission.UPDATE_CARD_CONFIG })

        const { status } = await response
        if (status === 200) {
          this.fetchRouteConfig()
          this.hideModal('modal-lg')
          const requestToText = this.$t('Your request to')
          const text = this.$t('Profit Management was successful')
          this.alertSuccess({ text: `${requestToText} ${this.buttonLabel} ${text}` })
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isLoading = false
      }
    },
    onSelectInterestItem(items, activity, val) {
      this.routeConfigFormData.providerInstitutionId = items.providerInstitutionId
      this.routeConfigFormData.providerCustomerId = items.providerCustomerId
      this.routeConfigFormData.providerGatewayKey = items.providerGatewayKey
      this.routeConfigFormData.cardSettlementGL = items.cardSettlementGL
      this.routeConfigFormData.id = items.id
      this.routeConfigFormData.providerBaseUrl = items.providerBaseUrl
      this.setWithholdingTax(items.type, val)
      this.routeConfigFormData.applyWTH = items.applyWTH
      this.isReadonly = val === 'edit' ? this.isReadonly = false : this.isReadonly = true
      this.modalTitle = val === 'edit' ? this.$t('Edit Route Config') : this.$t('Profit Management')
      this.buttonLabel = this.$t('Update')
      this.$root.$emit('bv::show::modal', 'modal-lg')
    },
    resetModal() {
      this.routeConfigFormData.name = ''
      this.routeConfigFormData.type = ''
      this.routeConfigFormData.rate = ''
      this.routeConfigFormData.applyWTH = false
      this.isDisableApplyWTH = false
      this.isLoading = false
      // this.buttonLabel = this.$t('Save')
      // this.modalTitle = this.$t('Create Profit')
      this.isReadonly = false
    },
    async fetchRouteConfig() {
      try {
        this.isBusy = true
        this.hideModal('modal-filter')
        const response = await this.getRouteConfigList({
          search: this.filter,
          page: this.currentPage,
          limit: this.perPage,
          permission: eChannelsPermission.VIEW_CARD_CONFIG,
        })
        const { status, data } = response
        if (status === 200 && data.data) {
          // this.routeConfigList = data.data
          this.routeConfigList = data.data.map(items => ({
            ...items.card,
            ...items,
          }))
          this.totalCount = data.recordCount
        } else {
          this.routeConfigList = []
          this.totalCount = 0
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isBusy = false
      }
    },
    async generateKey() {
      try {
        this.isBusy = true
        const formData = {
          thirdPartyProvider: 2,
        }
        const response = await this.updateKeyPair({ formData, permission: eChannelsPermission.UPDATE_CARD_CONFIG })
        const { status, data } = response
        if (status === 200 && data) {
          this.generatedKey = data.publicKey
        }
        this.$nextTick(() => {
          this.$root.$emit('bv::show::modal', 'key-display-modal')
        })
      } catch (error) {
        this.alertError({ text: this.$t('Error generating PIN'), error })
      } finally {
        this.isBusy = false
        this.showSpinner = false
      }
    },

    resetFilters() {
      this.filter = { ...null }
    },
    resetFilter() {
      this.filter = { ...null }
      this.fetchRouteConfig()
    },
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
.pin-code {
  font-size: 16px;
  font-weight: 500;
  color: #2c3e50;
}

.pin-container {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 0.375rem;
  padding: 1.5rem;
}

.pin-display {
  background-color: white;
  border: 2px solid #007bff;
  border-radius: 0.25rem;
  padding: 1.25rem 0.5rem;
  overflow-x: scroll;
}

.copy-button {
  cursor: pointer;
  padding: 1rem 1.2rem;
  background-color: #e9ecef;
  width: fit-content;
  display: flex;
  align-items: center;
  border-radius: 0.25rem;
  margin-bottom: 10px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
